// extracted by mini-css-extract-plugin
export var centerText = "_73-8";
export var container = "_73-0";
export var doughnutContainer = "_73-7";
export var legend = "_73-a";
export var legendItemColorDisplay = "_73-b";
export var legendItemLabel = "_73-d";
export var legendItemValue = "_73-c";
export var lg = "_73-5";
export var maxWidth = "_73-9";
export var md = "_73-4";
export var responsive = "_73-6";
export var sm = "_73-3";
export var xs = "_73-2";
export var xxs = "_73-1";